import React from 'react';
import { Question } from '../types';

interface QuestionPreviewDisplayProps {
    question: Question;
    handleEditQuestion: () => void;
    handleDeleteQuestion: () => void;
    children: React.ReactNode;
}

export default (props: QuestionPreviewDisplayProps) => {

    
    const { question, handleDeleteQuestion, handleEditQuestion, children } = props;

    return (
        <div className="flex flex-col p-1 rounded-md capitalize text-white">
            <div className="flex flex-col-reverse md:flex-row justify-between">
                <p className="text-xl md:text-2xl"><span className="text-[#3da8e2] mr-2">Type:</span><span className="border-b-2 md:border-b-4">{question.type}</span></p>
                <div className="self-end flex md:gap-5">
                    <button onClick={handleEditQuestion} className="text-xl md:text-2xl text-[#3da8e2] hover:text-white">Edit</button>
                    <button onClick={handleDeleteQuestion} className="ml-5 text-xl md:text-2xl text-[#3da8e2] hover:text-red-500">Delete</button>
                </div>
            </div>            
            <h3 className="my-7 md:my-10 text-2xl md:text-4xl text-[#3da8e2]">{question.questionText}</h3>
            {children}
        </div>
    )

}